import { FieldNameCell } from '@cibo/landmanager'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useFieldTraitColumns = ({
  traitIds,
  renderTraitCell,
}: {
  traitIds: string[]
  renderTraitCell: (traitId: string) => (params: GridRenderCellParams) => ReactElement
}): GridColDef[] => {
  const { t } = useTranslation('traits')

  return useMemo(
    () => [
      {
        field: 'field',
        headerName: t('field', { ns: '@cibo/landmanager/FieldColumns' }),
        flex: 1.5,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <FieldNameCell {...(params as any)} row={params.row.fieldModel} thumbnailSize={32} />
        ),
      },
      ...traitIds.map((traitId: string) => ({
        field: traitId,
        headerName: t(traitId),
        flex: 1,
        sortable: false,
        renderCell: renderTraitCell(traitId),
      })),
    ],
    [traitIds, renderTraitCell, t]
  )
}
